import { type UUID } from 'crypto';
import dayjs, { type Dayjs } from 'dayjs';

export class Comment {
    public id: UUID;
    public reportId: UUID;
    public comment: string;
    public userId: number;
    public firstname: string;
    public lastname: string;
    public email?: string;
    public phone?: string;
    public phoneCountry?: string;
    public createdAt: Dayjs;

    constructor(dto: CommentDTO) {
        this.id = dto.id;
        this.reportId = dto.reportId;
        this.comment = dto.comment;
        this.userId = dto.userId;
        this.firstname = dto.firstname;
        this.lastname = dto.lastname;
        this.email = dto.email;
        this.phone = dto.phone;
        this.phoneCountry = dto.phoneCountry;
        this.createdAt = dayjs.unix(+dto.createdAt / 1000);
    }
}

export interface CommentDTO {
    id: UUID;
    reportId: UUID;
    comment: string;
    userId: number;
    firstname: string;
    lastname: string;
    email?: string;
    phone?: string;
    phoneCountry?: string;
    createdAt: number;
};

export interface CreateCommentDTO {
    comment: string;
    userId: number;
    firstname: string;
    lastname: string;
    email?: string;
    phone?: string;
    phoneCountry?: string;
};